import { ExternalCalendarEvent } from '@griply/types';

// One rule for both platforms: an event is all-day only when the provider sent date-only
// boundaries. A *timed* event that happens to span midnight (18:00 → 02:00) stays timed and
// renders across the night — mobile used to widen it into the all-day row, which is the
// drift this replaces.
export const isExternalEventAllDay = (event: ExternalCalendarEvent): boolean =>
  !!event.start.date && !!event.end.date;
